import { inject, Injectable } from '@angular/core';
import Keycloak from 'keycloak-js';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private readonly keycloak = inject(Keycloak);

  /**
   * Checks if the user is authenticated
   */
  isAuthenticated(): boolean {
    return this.keycloak.authenticated ?? false;
  }

  /**
   * Returns the access token
   */
  getToken(): string | undefined {
    return this.keycloak.token;
  }

  /**
   * Returns the user information
   */
  getUserProfile() {
    return this.keycloak.loadUserProfile();
  }

  /**
   * Logs out the user
   */
  logout(): void {
    this.keycloak.logout();
  }

  /**
   * Redirects to the Keycloak login page
   */
  login(): void {
    this.keycloak.login();
  }

  /**
   * Checks if the user belongs to a specific group
   * @param groupPath Full path of the group (e.g.: /stefconnect/admin)
   */
  hasGroup(groupPath: string): boolean {
    const tokenParsed = this.keycloak.tokenParsed;
    if (!tokenParsed) {
      return false;
    }

    // Keycloak stores groups in the token
    const groups = tokenParsed['groups'] as string[] | undefined;
    return groups ? groups.includes(groupPath) : false;
  }

  /**
   * Returns the user's first name from the token
   */
  getUserGivenName(): string {
    const tokenParsed = this.keycloak.tokenParsed;
    return (tokenParsed?.['given_name'] as string) || 'Administrateur';
  }

  /**
   * Returns the user's email from the token
   */
  getUserEmail(): string {
    const tokenParsed = this.keycloak.tokenParsed;
    return (tokenParsed?.['email'] as string) || 'admin@stef.com';
  }
}
